module.exports = __webpack_public_path__ + "static/media/large-event-grid-image.d1e49c7e.jpg";